export const en_master = {
    'basket': {
        "sending_to": "Sending to:",
        "bonus_balance": "Bonus balance",
        "bonus_data": "Bonus data",
        "valid_for": "valid for {{bonusValidity}} days",
        "worth": "<span>Worth of {{faceValue}} {{sourceCurrencyCode}}</span><br /><span>is {{totalLocalCurrencyAmount}} {{currencyCode}}</span>"
    },
    'login': {
        'register_link': "Register as a New User",
        'reset_password': 'Reset Password',
        'preceed_to_login': 'Proceed to Login',
        'link_login': 'Already have an account? Login',
        'title_account_verify': 'Account Verification',
        'resend_code': 'Resend Code',
        'didnt_receive_code': "Didn't receive the code. Resend?",
        'code_resent': "Code has been resent",
        'verify_code_label': 'Verification Code',
        'verify_label': 'Verify',
        'reload': 'Reload',
        "remember_me": "Remember me?",
        'current_password': "Current Password",
        'new_password': "New Password",
        'confirm_new_password': "Confirm New Password",
        'password_successfully_changed': "Password successfully changed",
        'change_password': "Change Password"
    },
    'menu': {
        'dashboard': 'Dashboard',
        'operator': 'Operator',
        'send_balance': 'Send Top-up',
        'buy_gift_card': 'Send Gift Card',
        'auto_balance': 'Auto Top-up',
        'order_history': 'Order History',
        'order_summary': 'Order Summary',
        'receipt': 'Receipt',
        'support': 'Support',
        'store_locator': 'Store Locator',
        'logout': 'Logout',
        'login': 'Login',
        'register': 'Register',
        'number': 'Number',
        'order': 'Order',
        'summary': 'Summary',
        'payment': 'Payment',
        'verify_code': 'Verify Code',
        'change_password': "Change Password",
        'forgot_password': 'Forgot Password',
        'forgot_password_confirm': 'Forgot Password Confirmation',
        "support_tickets": "Support Tickets",
        "reward_points": "Reward Points",
        "account": "Account",
        "contact_list": "Contact List",
        "manage-payments": "Manage Payments Options",
        "stored-cards" : "Saved Credit Cards",
        "note" : "Note: Cards associated with recurring profiles cannot be deleted",
        "checkout-as-guest" : "Checkout as Guest",
        "guest-email" : "Guest Email",
    },
    'home': {
        'welcome': 'Welcome to eTopup Online'
    },
    'send_balance': {
        'no_country_found': "No Country found for the search criteria",
        'confirm_password_label': 'Confirm Password',
        'password_label': 'Password',
        'user_name_label': 'Email Address',
        'signup_button': 'Sign Up from bp',
        'pay_button_title': 'Pay',
        'checkout_button_title': 'Checkout',
        'next_button_title': 'Next',
        'mobile_number_placeholder': 'Mobile Number',
        'credit_card_number': "Credit Card Number",
        'from_credit_card': 'From Credit Card',
        'from_paypal': 'From Paypal',
        'from_reward_points': "From Reward Points",
        'auto_balance_title': 'Set Auto Top-up',
        'balance_pending': 'Top-up Pending',
        'repeat_button_title': 'REPEAT',
        'repeat_transaction': "Repeat Transaction",
        'debit_credit_placeholder': "Credit/Debit Card",
        'card_number_placeholder': 'Credit/Debit Card Number',
        'expiration_date_placeholder': 'Expiration Date',
        'cvv_placeholder': 'CVV',
        'full_name_placeholder': 'Full Name',
        'billing_address_placeholder': 'BILLING ADDRESS',
        'street_address_placeholder': 'Street Address',
        'city_placehoder': 'City',
        'postal_code_placeholder': 'Zip/Postal Code',
        'state_placeholder': 'State',
        'country_placeholder': 'Country',
        'find_credit_card_number': 'WHERE CAN I FIND MY CREDIT CARD NUMBERS',
        'stored_credit_card': "Stored Credit/Debit Card",
        'stored_cc_future': "Store Credit/Debit Card for future use",
        'new_card_type': 'New Credit/Debit Card',
        'select_card_type': 'Select Credit or Debit Card',
        'transaction_id': 'Transaction: # {{transactionId}}',
        'balance_failed': 'Top-up Failed',
        'recharge_to': 'Recharge to',
        'failed': 'failed',
        'pending': 'pending',
        'check_valid_number_1': 'Please check if it is a valid',
        'check_valid_number_2': 'number and try again',
        'balance_success': 'Top-up Successful',
        'label_trasaction': 'Transaction: ',
        'incorrect_phone_number': "Your phone number isn't correct please try again!",
        'ok': 'OK',
        'view_all_link': 'View All',
        'balance_phone_number_label': 'Top-up phone number',
        'exchange_rate_label': 'Exchange Rate',
        'select_amt_label': 'Select Top-up amt',
        'select_amt_label_gift': 'Select Gift Amount',
        'select_operator': 'Select Operator',
        'select_operator_gift': 'Select Gift Card Operator',
        'select_sku': 'Select Amount',
        "search_country": "Search Country",
        'click_select_country': 'Click here to select Country',
        'select_country': 'Please select Country',
        'select_country_placeholder': 'Select Country',
        'enter_mobile_number': "Please enter mobile number",
        'operator_missing': 'Please select the operator.',
        'amount_missing': 'Please select the Top-Up amount.',
        'coupon_code_label': 'Coupon Code',
        'reward_points_label': 'Reward Points',
        'coupon_apply_label': 'Apply',
        'coupon_remove_label':'Remove',
        'coupon_applied_message': `Coupon Code applied. You will receive a discount of {{discount}} {{currency}}.`,
        'cover_sales_tax_message': `I want to cover the Tax and deliver {{currencyCode}} {{faceValue}} to the phone`,
        'reward_points_message': `You have {{reward}} reward points ({{discount}} {{currency}}). You can use up to {{discountTopup}} {{currency}} for this top-up.`,
        'zero_amount_payment_message': 'Congratulations! You have reward point to pay for this Top-up. You will not be charged for this transaction.',
        'paypal_message': "You have selected Paypal as Payment Method. When you click Pay, you will be redirected to Paypal web site to complete the payment",
        "payment_sub_heading": "",
        "topup_heading":"Send Top-up",
        "topup_sub_heading": "Enter the number that you would like to recharge",
        "viva_disclaimer": "The refills in this application are available for credit cards in E.E.U.U. For national use, Dominican Republic, the amounts will be invoiced in USD",
        "paypal_conversion_message": "Your PayPal transaction will be processed in US Dollars",
        "select_value" : "Select a value",
        "giftcard_delivery_disclaimer" : "The eGift Card will be delivered to the recipient via Email and SMS. Please ensure that this information is correct. This cannot be changed after the sale.",
        "enter_recipient_details": "Enter Recipient Details",
        "recipient_mobile" : "Recipient Mobile Number",
        "recipient_email" : "Recipient Email",
        "confirm_recipient_email" : "Confirm recipient email",
        "recipient_name" : "Recipient full name",
        "recipient_message" : "Message to recipient",
        "sender_details" : "Enter sender details",
        "sender_mobile": "Sender's mobile number",
        "sender_name" : "Sender's full name",
        "gift_card" : "Gift Card",
        "purchase_failed" : "Purchase failed",
        "purchase_pending": "Purchase Pending",
        "reward_code_applied": "Reward Code Applied",
        "pin_applied": "PIN Applied",
        "enter_reward_code" : "Enter Reward Code",
        "enter_pin" : "Enter PIN",
        "get_store_pin_balance_label":"Check PIN Balance",
        "store_pin_payment_msg" :"Congratulations! You will not be charged for this transaction. Please check your email for the receipt.",
    },
    'auto_balance': {
        'topup_day': "Top-up day",
        'signup_button': 'Sign Up from bp',
        'auto_balance_header': 'Active Auto Top-ups',
        'no_profile_msg': 'No Active auto top-up available. Please click below button to create new auto top-up.',
        'new_profile_button_title': 'New Auto Top-up',
        'back_to_home_title': 'Back to Home',
        'frequency_30days': '30 days',
        'frequency_15days': '15 days',
        'frequency_7days': '7 days',
        "week": "Week",
        "month": "Month",
        'enable_profile_button_title': 'Enable Auto Top-up',
        'frequency_label': 'Frequency',
        'balance_amount_label': 'Top-up Amount',
        'auto_balance_cancel_fail': "We are sorry. An error occurred while cancelling the auto top-up. Please contact customer support",
        'auto_balance_success': 'Auto Top-up successfully created.',
        'auto_balance_cancelled': 'Auto Top-up successfully cancelled.',
        'frequency_days': 'every {{frequencyDays}} days',
        'active_auto_topup_status': '{{frequency}} on {{topupDayString}}',
        'terms_and_conditions_msg': 'By Proceeding to Checkout you are agreeing to ',
        'terms_and_conditions_link': 'terms and conditions',
        'proceed_with_for_payment': 'Proceed with',
        'plus_bonus': '+ Bonus',
        'bonus_data': '& {{bonusData}} DATA',
        'profile_created': 'Auto Top-up Created',
        'cancel_message': `Are you sure want to cancel the Auto Top-up to Mobile Number +{{internationalCode}} {{localMobileNumber}} ?`,
        'schedule': "Schedule: Every {{freq}} on {{topupDayString}} starting {{startDateFormated}}. Note: You can cancel auto top-up any time. No question asked.",
        'schedule_short': "Every {{freq}} on {{topupDayString}} starting {{startDateFormated}}.",
        'starting': 'Starting',
        'contact_number': 'Sender Contact Number',
        'contact_number_missing' : `Please enter the sender's contact number.`
    },
    'receipt': {
        'recipient': 'Recipient',
        'price': 'Price',
        'balance': 'Top-up Amount',
        'less_tax': 'Less Tax ',
        'bonus_balance': 'Bonus Top-up',
        'bonus_data': 'Bonus Data ',
        'bonus_validity': 'Valid for {{bonusValidity}} days',
        'bonus_data_validity': 'Bonus valid for {{bonusValidity}} days',
        'total_balance': 'Total Top-up Amount',
        'total_data': 'Total data',
        'processing_fee': 'Convenience Fees',
        'total_payment': 'Total Payment',
        'promo_code_label': "Promo Code",
        'pin_code_label': "PIN",
        'promo_code_applied': 'Promo Code applied',
        'pin_code_applied': 'PIN applied',
        'promo_code_discount_label': 'Discount (Promo Coupon)',
        'pin_discount_label': 'PIN Discount',
        'get_store_pin_balance_label':'Check PIN Balance',
        'reward_point_discount_label': 'Reward Point Redemption',
        'sms_charge': 'SMS Charge',
        'send_sms': "Send Personal SMS",
        'sms_fee': "A Fee of {{fee}} cents apply",
        'i_have_coupon': "I have coupon code",
        'transactionNotCompleted': `We are sorry, but the transaction was not completed for <strong>{{productName}}</strong>  mobile number <strong>+{{internationalCountryCode}} {{mobileNumber}}</strong>, in the amount of <strong>{{faceValue}}</strong>.`,
        'transactionInProcess': `Your transaction for <strong>{{productName}}</strong>  mobile number <strong>+{{internationalCountryCode}} {{mobileNumber}}</strong>, in the amount of <strong>{{faceValue}}</strong>, is in the process of being fulfilled.`,
        'transactionPaymentSuspended': `Your transaction for <strong>{productName}</strong>  mobile number <strong>+{{internationalCountryCode}} {mobileNumber}</strong>, in the amount of <strong>{{faceValue}}</strong>, is not yet complete because the payment processor has not yet confirmed receipt of funds.`,
        'transactionNoCharge': "You have not been charged for this attempted transaction.",
        'supportMessage': `If you have any questions, please contact us via the <a href="#/tickets">Support Tickets</a> page or the Support button below.`,
        'supportTickets': `Support Tickets`,
        'checkMobileNumber': "Please check the Mobile Number and Carrier and try again.",
        'dataPlanAlreadyActive': "Sorry, this transaction cannot be completed because the data plan is already activated and has not expired.",
        'notificationEmail': `A notification email has been sent to <strong>{{userEmail}}</strong>. Please make a note of transaction number <strong>{{transactionId}}</strong> for future reference.`,
        'customerServiceDilligent': `Our Customer Support Team is working diligently to fulfill this transaction and may contact you for verification. You will not be charged until the transaction is successfully completed.`,
        'customerServicePaymentProcessor': `Our Customer Support Team is working diligently with the payment processor to ensure completion. You will be notified as soon as the transaction is fulfilled.`,
        'notify': `We will notify you when the transaction is complete.`,
        'net_charge': "Net Charge",
        'topup-timeout': "Top-up Time out",
        'topup-timeout-msg-1': "We are sorry. Unfortunately the connection timedout. Please standby.",
        'topup-timeout-msg-2': "We are trying to contact the server. Please be assured, if the transaction is not successful, you will not be charged for the transaction.",
        'topup-timeout-msg-3': "Once we get a response from server, we will redirect to the receipt of your transaction.",
        'topup-timeout-msg-4': "Redirecting in less than <strong>{{secondsLeft}} Seconds</strong>",
        'amount_charged': "Amount Charged",
        'from_paypal': "From Paypal",
        'from_cc': "To Credit Card",
        'deliver_to': "Deliver To",
        'delivery_email' : "Email",
        'delivery_mobile' : "Mobile",
        'delivery_message' : "Message",
        'resend_email' : "Resend Email",
        'amount' : "Amount",
        'transactionNotCompleted_giftcard' : `We are sorry, but the transaction was not completed for <strong>{{productName}}</strong> gift card, in the amount of <strong>{{faceValue}}</strong>.`,
        'transactionInProcess_giftcard': `Your transaction for <strong>{{productName}}</strong> gift card, in the amount of <strong>{{faceValue}}</strong>, is in the process of being fulfilled.`,
        'purchase-timeout': "Purchase Time out",
        'guest_email_address' : "Guest Email Address"
    },
    'support': {
        'signup_button': 'Sign Up from bp',
        'email_alert_msg': 'Please email us at {{supportEmail}}',
        'email_us_button_title': 'Email us',
        'chat_button_title': 'Chat'
    },
    'constants': {
        'welcome': 'Welcome to eTopup Online',
        'exit_app': 'Do you want to exit the app?',
        'auth_failed': 'Authentication failed or cancelled',
        'network_error': 'Network error. Please check your internet connection and try again.',
        'payment_network_error': 'Due to a network error, system is unable to find the status of your Top-up. Please go to Home page. If your Top-up is processed, you will see at the top of the screen.',
        'auto_profile_network_error': 'Due to a network error, system is unable to find the status of your profile. Please go to Home page. If your profile is processed, you will see at the Home page.',
        'general_network_error': 'A network error occurred. Please try again.',
        'empty_balance_history_msg': 'Thanks for choosing eTopupOnline.com. Get started with sending Top-up and create history!',
        'enter_number_for_balance': 'Enter the number that you would like to add Top-up to',
        'no_network_message': 'The device is not connected to internet. Please fix the internet connection and press RELOAD to continue',
        'selecte_provider': 'Please select your provider to proceed',
        'exclusive': 'Exclusive',
        'online_offer': 'Online Offer',
        'loading_msg': 'Loading. Please wait...',
        'check_app_version_msg': 'Checking App Version',
        'app_update_message': "App update!', 'A new version of the app has been released. You must update your app",
        'loading_user_settings_msg': 'Loading user settings. Please wait...',
        'loading_recent_trx_msg': 'Loading recent transactions and profiles. Please wait...',
        'contact_permissions_title': 'Contact Permission',
        'contact_permission_message': '{{appName}} app needs access to your contacts so you can select contact to send balance.',
    },
    'common': {
        'recharge': 'Recharge',
        'cancel_button': 'Cancel',
        'cancelled': 'Cancelled',
        'active': "Active",
        'rejected': "Rejected",
        'ok_button': 'OK',
        'sales_tax': 'Sales Tax',
        "extra": "extra",
        "pay": "Pay",
        "checkout": "Checkout",
        "next": "Next",
        "language": "Language",
        "menu": "Menu",
        "close": "Close",
        "ending": "Ending",
        "type": "Type",
        "question": "Question",
        "issue": "Issue",
        "subject": "Subject",
        "description": "Description",
        "submit": "Submit",
        "oops": "Oops..",
        "save": "Save",
        "top-up": "Top-up",
        "edit": "Edit",
        "remove": "Remove",
        "select_state": "Select state",
        "hello": "Hello",
        "policy": "Policy",
        "plan": "Data Plan",
        "new": "New",
        "notification-subscribe-button" : "Subscribe to Notifications",
        "notification-unsubscribe-button" : "Unsubscribe from Notifications",
        "notification-text" : "Subscribe to get updates on your mobile or computer when the transaction status changes and get notifications about our exciting promotions."
    },
    'error': {
        'validation_error': 'The data is either incomplete or invalid. Please fix the data before proceeding',
        'error_mobile_number': 'Please correct the mobile number.',
        'error_credit_card': 'Please check credit card details and try again.',
        'user_locked': 'Invalid user is locked out. Please contact customer support or try after some time.',
        'registration_problem': 'There are problem during registration. Please try again.',
        'error_forgot_password': 'The email address is not registered with us. Please enter a registered email address.',
        'reward_points_limit_error_message': `The maximum redemption amount is {{discount}} {{currency}}`,
        'reward_points_min_limit_error_message': `The minimum redemption amount is {{discount}} {{currency}}`,
        'reward_points_invalid_number': 'Please enter valid number',
        'general_error': "Error occurred. Please try again",
        'error_contact_support': "We are sorry. some error occured while performing this operation. Please try again or contact customer support"
    },
    'messages': {
        'reset_password_email_1': 'We have sent an email containing a link to reset your password.\nClick on the link and you will be prompted to enter a new password.',
        'reset_password_email_2': 'Once you have changed the password, you can proceed further.',
        'verification_success': 'The code verification is successful. You will be redirected to login page.',
        'code_sent': 'Code has been successfully sent.',
        'verification_code_sent_1': 'An email containing a verification code has been sent to',
        'verification_code_sent_2': "Please check your email (including any spam filters),\ncopy the code into the box below and then click on the 'Verify' button.",
        'different_currency': `We have detected that in past you performed transactions in {{homeCurrency}}, while the current transaction 
            is denominated in {{trxCurrency}}. You have a choice to pay in {{homeCurrency}}. Please tell us how would you like to proceed`,
        'pay_in_curr': "Pay in {{currency}}",
        'resend_email_success' : "Email was resent.",
        'resend_email_error' : "Error resending Email"
    },
    'social': {
        'error_play_service': 'Google play services is not running. exiting...',
        'error_google': 'Google error',
        'sign_in_cancel': 'Sign in cancelled',
        'sign_in_facebook': 'Sign in with Facebook',
        'sign_in_google': 'Sign in with Google'
    },
    'validations': {
        'mobile_number_length': "Mobile number must be {{length}} digits long",
        'mobile_number_invalid': "Please enter a valid mobile number",
        'user_name_required': 'Email is required',
        'valid_email': 'Please enter a valid email',
        'password_required': 'Password is required',
        'current_password_required': 'Current Password is required',
        'password_char_length': 'Password must be at least 6 character long',
        'pass_rule_2': 'Password must have one lower case character',
        'pass_rule_3': 'Password must have one upper case character',
        'pass_rule_4': 'Password must have one numeric character',
        'password_char_type': 'Password must have at least one lowercase, one uppercase and one digit.',
        'password_message': 'Passwords must have at least 6 characters and contain at least 1 uppercase letter, 1 lowercase letter and 1 number.',
        'confirm_password': 'Password and Confirm Password must match',
        'confirm_password_short': 'Password must match',
        'error_type_validation': 'Error Occurred validating {{type}} token',
        'invalid_user_name': 'Invalid user name.',
        'username_already_taken': 'Username is already taken.',
        'invalid_id_pass': 'Invalid user name or password',
        'valid_verification_code': 'Please enter a valid code',
        'invalid_code': 'Invalid code',
        'credit_card_required_validation': 'Credit Card Number is required',
        'credit_card_validation': 'Please enter valid Credit Card Number',
        'month_required_validation': 'MM/YY is required',
        'month_validation': 'Invalid MM/YY',
        'cvv_required_validation': 'CVV Code is required',
        'cvv_validation': 'Invalid CVV',
        'select_credit_card': 'Please select Credit Card',
        'full_name_required': 'Full Name is required',
        'street_address_required': 'Street Address is required',
        'city_required': 'City is required',
        'state_required': 'State is required',
        'country_required': "Country is required",
        'zip_required': 'Zip code is required',
        'zip_validation': 'Please enter a valid Zip/Postal Code',
        'required_validation': '{{name}} is required',
        'email_validation': '{{name}} must be valid email',
        'min_length_validation': '{{name}} must be at least {{length}} character long',
        'max_length_validation': '{{name}} must be at less than {{length}} character long',
        'lower_case_validation': '{{name}} must have at least one lower case character',
        'upper_case_validation': '{{name}} must have at least one upper case character',
        'numeric_validation': '{{name}} must have at least one number type character',
        'invalid_validation': '{{name}} is invalid',
        'coupon_code_lenght_validation': 'Coupon Code must be at least 5 characters long',
        'coupon_code_validation': 'Please enter valid Coupon Code',
        'coupon_code_applied': 'Coupon Code applied successfully',
        'reward_points_applied_success': 'Reward Points applied successfully',
        'reward_points_applied': `Congratulations! You are using {{rewardPointsUsed}} points towards this top-up. You will now be charged a net amount of {{netCharge}} {{currency}}.`,
        'reward_points_applied_full_amount': `Congratulations! You are using {{rewardPointsUsed}} points towards this top-up. You will not be charged for this transaction.`,
        'mobile_number_required': "Mobile number is required",
        'operator_required': "Operator is required",
        'recipient_mobile_required' : `Recipient's mobile is required`,
        'recipient_email_required' : `Recipient's email is required`,
        'recipient_name_required' : `Recipient's full name is required`,
        'sender_name_required' : `Sender's full name is required`,
        'sender_mobile_required' : `Sender's mobile is required`,
        'recipient_email_confirm' : 'Recipient email and confirm email must match',
        'enter_valid_recipient_info' : 'Please enter correct recipient and sender information.',
        'guest_email_required' : 'Guest Email is Required',
    },
    "myaccount": {
        'createdOnLabel': 'created on',
        'updatedOnLabel': 'updated on',
        'statusLabel': 'status',
        "new_contact": "Create new contact",
        "edit_contact": "Edit contact",
        "contact_saved": "Contact successfully saved.",
        "new_comment": "New comment",
        "post_comment": "Post your comments here",
        "new_ticket": "Create new Ticket",
        "no_ticket": "You do not have any support ticket.",
        "no_auto_topup": "You don't have any active Auto-topups",
        "no_topup": "You do not have any Top-up",
        "no_ticket_message": "If you have any issue or question, click <a href='#/ticket/new'>here</a> to open a new ticket.",
        "error_subject": "Please enter the subject",
        "error_description": "Please enter the description",
        "ticket_created": "Your ticket has been created. We will get back to you shortly.",
        "comments_posted": "Your comment has been successfully posted. Our support team will reply shortly",
        "ticeket_detail": "Ticket Detail",
        "delete-auto-topup-confirm-message": "Are you sure you want to cancel the Auto top-up",
        "delete-contact-confirm-message": "Are you sure you want to cancel this Contact entry",
        "review-history": "Review history",
        "reward-point-balance-msg": "You have {{rewardPointBalance}} reward points.",
        "date": "Date",
        "points_earned": "Points Earned",
        "points_used": "Points Used",
        "balance": "Balance",
        "reward_points_policy":"reward points policy",
        "delete_stored-card-message" : "Are you sure you want to delete this Credit Card?"
    }
};